<article *transloco="let transloco" class="invoice py-25">

    <h2 
        class="primary-text"
        [ngClass]="{'my-0' : this.transactionService.transactionStatusItems?.secondaryText !== '',
            'mt-0' : this.transactionService.transactionStatusItems?.secondaryText === ''}">
    {{ this.transactionService.transactionStatusItems?.primaryText }}</h2>
    <p *ngIf="this.transactionService.transactionStatusItems?.secondaryText !== ''" class="secondary-text text-center mb-6">{{ this.transactionService.transactionStatusItems?.secondaryText }}</p>

    <index-grid class="text-center">
        <index-grid-column child-horizontal-alignment="left">
          <h3>{{ transloco('InvoiceNumber') | uppercase }}</h3>
            <p>{{ this.invoiceService.invoice?.invoiceNumber }}</p>
        </index-grid-column>
        <index-grid-column child-horizontal-alignment="center">
          <h3>{{ transloco('SentDate') | uppercase }}</h3>
            <p>{{ this.invoiceService.invoice?.localFirstSentDateTime !== null && this.invoiceService.invoice?.localFirstSentDateTime !== '-' ? (this.invoiceService.invoice?.localFirstSentDateTime) : '-' }}</p>
        </index-grid-column>
        <index-grid-column child-horizontal-alignment="center">
          <h3>{{ transloco('DueDate') | uppercase }}</h3>
            <p>{{ this.invoiceService.invoice?.dueDate !== null && this.invoiceService.invoice?.dueDate !== '-' ? (this.invoiceService.invoice?.dueDate) : '-' }}</p>
        </index-grid-column>
        <index-grid-column child-horizontal-alignment="right">
          <h3>{{ transloco('Status') | uppercase }}</h3>
            <index-pill type="light" color="{{ this.transactionService.transactionStatusItems?.statusColor }}" class="text-center">{{ this.transactionService.transactionStatusItems?.statusLabel }}</index-pill>
        </index-grid-column>
    </index-grid>

    <index-grid class="border-b-0">
        <index-grid-column size="6" child-horizontal-alignment="left">
            <h3>{{ this.invoicingService.invoicing.businessName }}</h3>
            <address>
              <p *ngIf="this.locationService.location.address"><span [innerHTML]="this.locationService.location.address"></span></p>
              <p *ngIf="this.locationService.location.phone">{{ this.locationService.location.phone }}</p>
              <p *ngIf="this.locationService.location.email">{{ this.locationService.location.email }}</p>
            </address>
        </index-grid-column>
        <index-grid-column size="6" child-horizontal-alignment="center" class="customer-info">
          <h3>{{ transloco('CustomerInformation') }}</h3>
            <index-grid>
              <index-grid-column no-flex child-horizontal-alignment="left">
                <p><strong>{{ this.invoiceService.invoice?.firstName }} {{ this.invoiceService.invoice?.lastName }}</strong></p>
                <p *ngIf="this.invoiceService.invoice?.businessName">{{ this.invoiceService.invoice?.businessName }}</p>
                <div *ngIf="this.invoiceService.invoice?.businessId">
                  <br />
                  <p>{{ transloco('BusinessID') | uppercase }}</p>
                  <p>{{ this.invoiceService.invoice?.businessId }}</p>
                </div>
                <div *ngIf="this.invoiceService.invoice?.businessTaxId">
                  <br />
                  <p>{{ transloco('BusinessTaxID') | uppercase }}</p>
                  <p>{{ this.invoiceService.invoice?.businessTaxId }}</p>
                </div>
              </index-grid-column>
                <index-grid-column no-flex child-horizontal-alignment="left">
                  <p *ngIf="this.invoiceService.invoice?.phoneNumber">{{ this.invoiceService.invoice?.phoneNumber }}</p>
                  <p *ngIf="this.invoiceService.invoice?.emailAddress" class="email-address">{{ this.invoiceService.invoice?.emailAddress }}</p>
                  <br />
                  <address>
                    <p *ngIf="this.invoiceService.invoice?.address"><span [innerHTML]="this.invoiceService.invoice?.address"></span></p>
                  </address>
                </index-grid-column>
            </index-grid>
        </index-grid-column>
    </index-grid>

    <div class="transactions">
        <table class="transaction-items">
            <thead>
                <tr>
                    <th><h4>{{ transloco('ItemName') }}</h4></th>
                    <th><h4>{{ transloco('UnitPrice') }}</h4></th>
                    <th><h4>{{ transloco('Quantity') }}</h4></th>
                    <th><h4>{{ transloco('Amount') }}</h4></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of this.transactionService.transaction?.transactionItems">
                    <tr>
                        <td>
                          <p class="wrap-text">{{ row.name }}</p>
                            <p *ngFor="let modifier of row.modifiers" class="sub-item">{{ modifier.name }}</p>
                            <p *ngIf="row.isDiscounted" class="sub-item note"><span>{{ transloco('YouSaved') }}</span>&nbsp;<span class="currency">{{ row.discountTotal }}</span></p>
                        </td>
                        <td>
                            <p class="currency">{{ row.unitPrice }}</p>
                            <p class="sub-item"></p>
                        </td>
                        <td>
                            <p>{{ row.quantity }} <span *ngIf="row.unitOfMeasure">{{ row.unitOfMeasure }}</span></p>
                            <p class="sub-item"></p>
                        </td>
                        <td>
                            <p><strong class="currency">{{ row.amount }} {{row.taxable}}</strong></p>
                            <p *ngFor="let modifier of row.modifiers" class="sub-item"><strong class="currency">{{ modifier.amount }}</strong> <strong>{{row.taxable}}</strong></p>
                        </td>
                    </tr>
                </ng-container>

                <tr *ngIf="this.transactionService.transaction.transactionItems.length <= 0" class="empty-row">
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                </tr>
                <tr *ngIf="this.transactionService.transaction.transactionItems.length <= 1" class="empty-row">
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                </tr>
                <tr *ngIf="this.transactionService.transaction.transactionItems.length <= 2" class="empty-row">
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                </tr>
                <tr *ngIf="this.transactionService.transaction.transactionItems.length <= 3" class="empty-row">
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                    <td class="border-b-0"></td>
                </tr>

          </tbody>
      </table>

      <index-grid>
        <index-grid-column size="6" child-horizontal-alignment="right">
            <table class="transaction-totals">
                    <tr>
                        <td class="border-b-0"><h5>{{ transloco('Subtotal') }}</h5></td>
                        <td class="border-b-0"><p class="font-semibold currency">{{ this.transactionService.transaction?.subtotal }}</p></td>
                    </tr>
                    <tr>
                        <td class="border-b-0">
                            <h5>{{ transloco('DiscountTotal') }}</h5>
                            <p *ngFor="let discount of this.transactionService.transaction?.transactionDiscounts" class="sub-item note">
                              <span>{{discount?.discountDescription}}</span>&nbsp;<span class="currency">({{discount?.rate}})</span>
                            </p>
                        </td>
                        <td class="border-b-0">
                            <p class="font-semibold currency">{{ this.transactionService.transaction?.discountTotal }}</p>
                            <p *ngFor="let discount of this.transactionService.transaction?.transactionDiscounts" class="sub-item note currency">{{ discount.amount }}</p>
                        </td>
                    </tr>
                    <tr>
                        <td class="pb-0">
                          <h5>{{ transloco('Taxes&Fees') }}</h5>
                            <p *ngFor="let tax of this.transactionService.transaction?.transactionTaxes" class="sub-item note mb-5">
                                {{tax?.name}} ({{tax?.rate}})
                            </p>
                        </td>
                        <td class="pb-0">
                            <p class="font-semibold currency">{{ this.transactionService.transaction?.taxTotal }}</p>
                            <p *ngFor="let tax of this.transactionService.transaction?.transactionTaxes" class="sub-item note mb-5 currency">{{ tax?.amount }}</p>
                        </td>
                    </tr>
                    <tr>
                        <td class="pt-2 pb-3 border-b-4 border-black"><p class="font-semibold">{{ transloco('Total') }}</p></td>
                        <td class="pt-2 pb-3 border-b-4 border-black"><p class="font-semibold currency">{{ this.transactionService.transaction?.grandTotal }}</p></td>
                    </tr>
                    <tr>
                        <td class="pt-2 pb-3 border-b-0"><p class="font-semibold">{{ transloco('Paid') }}</p></td>
                        <td class="pt-2 pb-3 border-b-0"><p class="font-semibold currency">{{ this.transactionService.transaction?.tendersTotalAmount }}</p></td>
                    </tr>
                    <tr>
                        <td class="pt-2 pb-0 border-b-0"><p class="text-lg font-bold">{{ transloco('Due') }}</p></td>
                        <td class="pt-2 pb-0 border-b-0"><p class="text-lg font-bold currency">{{ this.transactionService.transaction?.balanceDueCurrencyFormat }}</p></td>
                    </tr>
                    <tr *ngIf="this.transactionService.transaction?.transactionStatusTypeId === (100002 || 100005 || 100009)">
                        <td class="pt-2 pb-0 border-b-0"><p class="text-lg font-bold">{{ transloco('Refunded') }}</p></td>
                        <td class="pt-2 pb-0 border-b-0"><p class="text-lg font-bold currency">{{ this.transactionService.transaction?.tendersTotalAmount }}</p></td>
                    </tr>
            </table>
        </index-grid-column>
        <index-grid-column no-flex size="8" child-horizontal-alignment="left">
            <div *ngIf="this.transactionService.transaction?.transactionNotes?.length" class="notes mb-12">
              <h4 class="mb-2">{{ transloco('Note') }}</h4>
            <ng-container *ngFor="let note of this.transactionService.transaction?.transactionNotes">
                <p *ngIf="note.note !== null" class="normal-case">{{ note.note }}</p>
            </ng-container>
            </div>

            <div *ngIf="this.transactionService.transaction?.transactionTenders?.length" class="tenders">
              <h4 class="mb-2">{{ transloco('Payments') }}</h4>
                <table class="w-full ">
                    <tr *ngFor="let tender of this.transactionService.transaction?.transactionTenders" class="normal-case">
                        <td class="w-5 pr-4 py-4 align-middle">{{ tender?.localCompletionDate !== null && tender?.localCompletionDate !== '-' ? (tender?.localCompletionDate) : '-' }}</td>
                        <td class="w-full px-4 py-4 align-middle">
                            <span class="flex justify-start items-center" *ngIf="tender.paymentTypeId === this.paymentTypeId.CreditCard || tender.paymentTypeId === this.paymentTypeId.DebitCard">
                                <index-image
                                    *ngIf="tender?.paymentCardTypeId !== null"
                                    alt-text="{{ 
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Visa ? 'Visa card icon' : 
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Mastercard ? 'Mastercard card icon' :
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Discover ? 'Discover card icon' :
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.AmericanExpress ? 'American Express card icon' : ''
                                    }}"
                                    src="assets/img/{{ 
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Visa ? 'icon-card-visa' : 
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Mastercard ? 'icon-card-mastercard' :
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Discover ? 'icon-card-discover' :
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.AmericanExpress ? 'icon-card-american-express' : ''
                                    }}.svg"
                                    class="mr-1">
                                    <span class="hidden">{{
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Visa ? 'Visa' : 
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Mastercard ? 'Mastercard' :
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.Discover ? 'Discover' :
                                        tender?.paymentCardTypeId === this.paymentCardTypeId.AmericanExpress ? 'American Express' : ''
                                    }}</span>
                                </index-image>
                                - {{ tender?.redactedInfo | slice:-4 }}
                            </span>
                            <span class="flex justify-start align-center" *ngIf="tender.paymentTypeId === this.paymentTypeId.Cash">
                              {{ transloco('Cash') | uppercase }} {{ tender?.redactedInfo | slice:-4 }}
                            </span>
                            <span class="flex justify-start align-center" *ngIf="tender.paymentTypeId === this.paymentTypeId.Check">
                              {{ transloco('Check') | uppercase }} {{ tender?.redactedInfo | slice:-4 }}
                            </span>
                            <span class="flex justify-start align-center" *ngIf="tender.paymentTypeId === this.paymentTypeId.GiftCertificate">
                              {{ transloco('GiftCertificate') | uppercase }} {{ tender?.redactedInfo | slice:-4 }}
                            </span>
                            <span class="flex justify-start align-center" *ngIf="tender.paymentTypeId === this.paymentTypeId.GiftCard">
                              {{ transloco('GiftCard') | uppercase }} - {{ tender?.redactedInfo | slice:-4 }}
                            </span>
                        </td>
                        <td class="w-5 px-4 py-4 align-middle font-semibold currency">{{ tender?.amountReceived }}</td>
                        <td class="w-5 pl-4 py-4 align-middle normal-case">{{ tender?.tenderType }}</td>
                    </tr>
                </table>
            </div>
        </index-grid-column>
      </index-grid>

  </div>

</article>
